module.exports = __webpack_public_path__ + "static/media/kyle_C.93df004a.png";